import { useCategories } from "../../providers/Categories";
import { Box } from "./categoryStyle";

const Category = ({ name, color, categoryId }) => {
  const { categorySetter } = useCategories();

  return (
    <Box
      color={color}
      id={`cat${categoryId}`}
      onClick={() => categorySetter(categoryId)}
    >
      <p>{name}</p>
    </Box>
  );
};

export default Category;
